import React from 'react';
import {LazyImage} from "../../../Components";

function DualBarSec({item,LinkDispatcher}){


    return(
        <div style={{order: 2,margin: "20px 16px 0 16px"}}>
            {item.title?<div className="section-title"><span>{item.title}</span></div>:null}
            <div className="block-pool" >
                <div className="block-item-horizontal">
                    <div  className={`wrapper ${item.has_shadow?"shadow-sec":""}`}
                         onClick={() => LinkDispatcher(item.items[0].link_to, item.items[0])}>
                        {item.items[0] ?
                            <>
                                {/*<img src={item.items[0].image} alt=""/>*/}
                                <LazyImage type={'side'} src={item.items[0].image}/>
                                <span className="block-title">{item.items[0].title}</span>
                            </>
                            : null}
                    </div>

                    <div  className={`wrapper ${item.has_shadow?"shadow-sec":""}`}
                         onClick={() => LinkDispatcher(item.items[1].link_to, item.items[1])}>
                        {item.items[1] ?
                            <>
                                {/*<img src={item.items[1].image} alt=""/>*/}
                                <LazyImage type={'side'} src={item.items[1].image}/>
                                <span className="block-title">{item.items[1].title}</span>
                            </>
                            : null}
                    </div>
                </div>
            </div>
            </div>
    )
}

export default DualBarSec
